import { Pipe, PipeTransform } from '@angular/core';

export type ByteUnit = 'B' | 'KB' | 'MB' | 'GB' | 'TB';
enum ByteUnitEnum {
    B = 0,
    KB = 1,
    MB = 2,
    GB = 3,
    TB = 4,
}

@Pipe({
    name: 'bytes',
    pure: false,
    standalone: true,
})
export class BytesPipe implements PipeTransform {

    transform(bytes: number, to?: ByteUnit, from: ByteUnit = 'B'): any {
        if (bytes === null || bytes === undefined || bytes < 0) return null;

        if (!to) {
            if (bytes === 0) return '0 B';
            let currentUnit = ByteUnitEnum.B;
            while (bytes >= 1024 && currentUnit <= ByteUnitEnum.TB) {
                bytes /= 1024;
                currentUnit++;
            }

            return bytes.toFixed(0) + ' ' + ByteUnitEnum[currentUnit];
        }

        if (ByteUnitEnum[from] < ByteUnitEnum[to]) {
            for (let i = ByteUnitEnum[from]; i <= ByteUnitEnum[to]; i++) {
                bytes /= 1024;
            }

            return bytes.toFixed(0) + ' ' + to;
        }

        if (ByteUnitEnum[from] > ByteUnitEnum[to]) {
            for (let i = ByteUnitEnum[from]; i >= ByteUnitEnum[to]; i--) {
                bytes *= 1024;
            }

            return bytes.toFixed(0) + ' ' + to;
        }

        if (ByteUnitEnum[from] === ByteUnitEnum[to]) {
            return bytes.toFixed(0) + ' ' + from;
        }
    }
}
